import { Home, TrendingUp, Activity, User } from 'lucide-react';
import { Skeleton } from './SkeletonBase';

export default function ActivitySkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <div className="max-w-2xl mx-auto">
        <header className="bg-white px-6 py-4 flex items-center justify-between sticky top-0 z-10 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <Skeleton className="w-10 h-10 rounded-xl" />
            <div>
              <Skeleton className="h-5 w-32 mb-1" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
          <Skeleton className="w-10 h-10 rounded-lg" />
        </header>

        <div className="p-4 space-y-6">
          <div className="bg-white rounded-2xl p-6 border border-gray-200">
            <div className="text-center mb-6">
              <div className="relative inline-block">
                <Skeleton className="w-32 h-32 rounded-full" />
              </div>
            </div>
            <Skeleton className="h-4 w-40 mx-auto" />
          </div>

          <div className="bg-white rounded-2xl p-5 border border-gray-200">
            <div className="flex items-center gap-2 mb-4">
              <Skeleton className="w-4 h-4 rounded" />
              <Skeleton className="h-4 w-28" />
            </div>

            <div className="space-y-3">
              {[1, 2, 3].map((i) => (
                <div key={i} className="p-4 rounded-xl border border-gray-200">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <Skeleton className="h-4 w-24 mb-2" />
                      <Skeleton className="h-3 w-32" />
                    </div>
                    <div className="flex items-center gap-1">
                      {[1, 2, 3].map((j) => (
                        <Skeleton key={j} className="w-2 h-2 rounded-full" />
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-8 w-16 rounded-lg" />
                    <Skeleton className="h-8 w-20 rounded-lg" />
                    <Skeleton className="h-8 w-18 rounded-lg" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-30 safe-area-inset-bottom">
          <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-around">
            <button className="flex flex-col items-center gap-1 text-gray-400 min-w-[60px]">
              <Home size={22} strokeWidth={2} />
              <span className="text-[10px] font-bold">Home</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-gray-400 min-w-[60px]">
              <TrendingUp size={22} strokeWidth={2} />
              <span className="text-[10px] font-bold">Progress</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-cyan-600 min-w-[60px] relative">
              <div className="absolute -top-1 w-12 h-0.5 bg-cyan-600 rounded-full"></div>
              <Activity size={22} strokeWidth={2.5} />
              <span className="text-[10px] font-bold">Activity</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-gray-400 min-w-[60px]">
              <User size={22} strokeWidth={2} />
              <span className="text-[10px] font-bold">Profile</span>
            </button>
          </div>
        </nav>
      </div>
    </div>
  );
}
